import { BannerLandscape } from '.';
import { BannerHeroSwiperSkeleton } from '../bannerHero';
import React from 'react';
import { useGetPageBannersQuery } from 'features/api/promoEngineApiSlice';
import { isServerSide } from 'utility/constant';

export const BannerLandscapeWrapper = ({
  pageId,
  showLoader,
  promoNumber,
  removePaddingLeft,
  removePaddingRight,
}: {
  pageId: string;
  showLoader: boolean;
  promoNumber: number;
  removePaddingLeft?: boolean;
  removePaddingRight?: boolean;
}) => {
  const { data, isLoading } = useGetPageBannersQuery(pageId, { skip: isServerSide, refetchOnMountOrArgChange: true });
  const banner = Reflect.get(data?.pageBannerList ?? {}, promoNumber) ?? undefined;

  if ((isLoading || isServerSide) && showLoader) {
    return <BannerHeroSwiperSkeleton />;
  }

  return (
    <BannerLandscape data={banner} removePaddingLeft={removePaddingLeft} removePaddingRight={removePaddingRight} />
  );
};
